import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { STATUS_CODE } from '../constants/verificationStatus';
import { CSPUrlsMap } from '../routes/CSPUrlsMap';

export const baseQuery = fetchBaseQuery({
  baseUrl: process.env.CSP_MIDDLEWARE_API,
  prepareHeaders: (headers, { getState }) => {
    const state = getState();
    const cspToken = state?.authentication.authDetails.cspAccessToken;
    const auth0Token = headers.get('customAuthToken');

    headers.delete('customAuthToken');

    if (auth0Token) {
      headers.set('Authorization', `Bearer ${auth0Token}`);
    } else if (cspToken) {
      headers.set('Authorization', `${cspToken}`);
    }
    return headers;
  }
});

const baseQueryWithTimeout = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  // Csp token timeout, response is unauthorized
  // Redirect to login page

  if (
    result?.error?.status === STATUS_CODE.UNAUTHORIZED ||
    result?.error?.originalStatus === STATUS_CODE.UNAUTHORIZED
  ) {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = CSPUrlsMap.login.url;
  }

  return result;
};

export default baseQueryWithTimeout;
